import { render, staticRenderFns } from "./MerchantView.vue?vue&type=template&id=682f5282"
import script from "./MerchantView.vue?vue&type=script&lang=js"
export * from "./MerchantView.vue?vue&type=script&lang=js"
import style0 from "./MerchantView.vue?vue&type=style&index=0&id=682f5282&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports